import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { Observable, ReplaySubject, Subject, mergeMap, takeUntil } from 'rxjs';
import { A11y, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import SwiperCore, { Keyboard, Mousewheel } from 'swiper';

import {
  LARGE_BREAKPOINT_WIDTH,
  MEDIUM_BREAKPOINT_WIDTH,
  SMALL_BREAKPOINT_WIDTH,
} from 'ish-core/configurations/injection-keys';
import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentletHelper } from '../../../models/contentlet/custom-dot-cms-contentlet.helper';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { configureSwiper, sliceContents } from '../../../utils/dot-cms-utils';

SwiperCore.use([Keyboard, Mousewheel]);

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

@Component({
  selector: 'custom-dot-cms-global-carousel',
  templateUrl: './dot-cms-global-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsGlobalCarouselComponent implements DotCmsContentTypeComponent, OnInit, OnChanges, OnDestroy {
  @Input() identifier: string;
  contentlet$: Observable<CustomDotCmsContentlet>;
  contentlet: CustomDotCmsContentlet;
  slideItems: number;
  posIni: number;

  @ViewChild('ngbCarousel') carousel: NgbCarousel;

  carouselContents: CustomDotCmsContentlet[];
  private destroy$ = new Subject<void>();
  itemGridSize = 12;
  contentTypes: string[] = ['banners', 'images', 'videos', 'productsTooltip', 'blogs', 'categoryCard'];
  identifier$ = new ReplaySubject<string>(1);
  swiperConfig: SwiperOptions;

  breakPointWidths: [number, number, number];
  constructor(
    private dotCmsFacade: DotCmsFacade,
    @Inject(SMALL_BREAKPOINT_WIDTH) private smallBreakpointWidth: number,
    @Inject(MEDIUM_BREAKPOINT_WIDTH) private mediumBreakpointWidth: number,
    @Inject(LARGE_BREAKPOINT_WIDTH) private largeBreakpointWidth: number
  ) {
    this.swiperConfig = {
      direction: 'horizontal',
      navigation: true,
      observer: true,
      observeParents: true,
      mousewheel: { forceToAxis: true },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    };
    this.breakPointWidths = [this.smallBreakpointWidth, this.mediumBreakpointWidth, this.largeBreakpointWidth];
  }

  ngOnInit() {
    this.identifier$
      .pipe(
        whenTruthy(),
        mergeMap(identifier => this.dotCmsFacade.getContentletByIdentifier$(identifier)),
        takeUntil(this.destroy$)
      )
      .subscribe(contentlet => {
        this.contentlet = contentlet;
        this.carouselContents = CustomDotCmsContentletHelper.getSortedSubContentlets(
          contentlet,
          this.contentTypes,
          'sortOrder'
        );
      });

    //No.of.Items Logic
    // this.carouselContents = this.rearrangeCategories(this.carouselContents);
    this.carouselContents = sliceContents(this.contentlet.noOfItems, this.carouselContents);
    Object.entries(configureSwiper(this.contentlet, this.breakPointWidths)).map(([key, value]) => {
      //@ts-ignore
      this.swiperConfig[key] = value;
    });

    this.swiperConfig.navigation = this.carouselContents.length > this.contentlet.slideItems ? true : false;
    this.swiperConfig.loop = this.carouselContents.length > this.contentlet.slideItems ? true : false;
  }

  rearrangeCategories(contentletArray: CustomDotCmsContentlet[]) {
    if (
      this.contentlet.loop &&
      this.contentlet.slideItems !== 0 &&
      contentletArray.length > this.contentlet.slideItems &&
      contentletArray.length % this.contentlet.slideItems !== 0
    ) {
      let categoriesIn = contentletArray;
      const sliceval = this.contentlet.slideItems - (contentletArray.length % this.contentlet.slideItems);
      categoriesIn = [...categoriesIn, ...categoriesIn.slice(0, sliceval)];
      contentletArray = categoriesIn;
    }
    return contentletArray;
  }

  ngOnChanges(): void {
    this.identifier$.next(this.identifier);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  cssClasses(contentlet: CustomDotCmsContentlet): string {
    if (contentlet?.maxWidth) {
      return 'default-carousel-class full-width-carousel';
    }
    return 'default-carousel-class';
  }
}
